import { render, staticRenderFns } from "./xcvideo.vue?vue&type=template&id=4e06fd9c&scoped=true&"
import script from "./xcvideo.vue?vue&type=script&lang=js&"
export * from "./xcvideo.vue?vue&type=script&lang=js&"
import style0 from "./xcvideo.vue?vue&type=style&index=0&id=4e06fd9c&lang=stylus&scoped=true&"
import style1 from "./xcvideo.vue?vue&type=style&index=1&id=4e06fd9c&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06fd9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e06fd9c')) {
      api.createRecord('4e06fd9c', component.options)
    } else {
      api.reload('4e06fd9c', component.options)
    }
    module.hot.accept("./xcvideo.vue?vue&type=template&id=4e06fd9c&scoped=true&", function () {
      api.rerender('4e06fd9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/video/xcvideo.vue"
export default component.exports